import React, { useEffect, useState, useCallback } from "react";
import "./listVolunteer.scss";

import HeaderBar from "../../components/headerBar/HeaderBar";
import SearchInput from "../../components/searchInput/SearchInput";
import VoidSpace from "../../components/voidSpace/VoidSpace";
import VolunteerInfoBox from "../../components/volunteerInfoBox/VolunteerInfoBox";
import VolunteerDetails from "../../components/volunteerDetails/VolunteerDetails";

import HandshakeIcon from "@mui/icons-material/Handshake";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

import { useParams } from "react-router-dom";
import { setGlobalState } from "../../utils/state";
import { gestioneSnackbar } from "../../utils/common";
import { Button, Col, Row } from "react-bootstrap";
import { t } from "i18next";
import {
  acceptSubscriptionWS,
  changePermissionAdminWS,
  getListRequestSubscriptionWS,
  getVolunteersAssociationWS,
  changePermissionMemberWS,
  removeVolunteerWS,
} from "./api/listVolunteerApi";
import { isEmpty } from "../../utils/validation";
import CustomTabs from "../../components/customTabs/CustomTabs";

const ListVolunteer = () => {
  const { id_association } = useParams();

  const [volunteers, setVolunteers] = useState([]);
  const [filteredVolunteers, setFilteredVolunteers] = useState([]);
  const [request, setRequest] = useState([]);
  const [filteredRequest, setFilteredRequest] = useState([]);

  const [search, setSearch] = useState("");

  const [accepted, setAccepted] = useState(true);

  //Passo questa funzione a volunteerInfoBox per poter aggiornare contenuti quando
  //clicco rimuovi utente o operazioni simili
  const refreshContent = useCallback(() => {
    getVolunteersAssociationWS({ id_association })
      .then((res) => {
        setVolunteers(res);
        setFilteredVolunteers(res);
      })
      .catch((err) => console.log(err));

    getListRequestSubscriptionWS({ id_association })
      .then((res) => {
        setRequest(res);
        setFilteredRequest(res);
      })
      .catch((err) => console.log(err));
  }, [id_association]); // dipende da id_association

  useEffect(() => {
    setGlobalState("selectedIdBottomBar", 2);
    refreshContent();
  }, [refreshContent]); // adesso puoi metterla nelle dipendenze

  const searchFunction = () => {
    if (!isEmpty(search)) {
      setFilteredRequest(
        request.filter((person) => {
          const name = person.name?.toLowerCase() || "";
          const surname = person.surname?.toLowerCase() || "";
          const email = person.email?.toLowerCase() || "";
          const tel = person.tel?.toLowerCase() || "";

          return (
            name.includes(search.toLowerCase()) ||
            surname.includes(search.toLowerCase()) ||
            email.includes(search.toLowerCase()) ||
            tel.includes(search.toLowerCase())
          );
        })
      );

      setFilteredVolunteers(
        volunteers.filter((person) => {
          const name = person.name?.toLowerCase() || "";
          const surname = person.surname?.toLowerCase() || "";
          const email = person.email?.toLowerCase() || "";
          const tel = person.tel?.toLowerCase() || "";

          return (
            name.includes(search.toLowerCase()) ||
            surname.includes(search.toLowerCase()) ||
            email.includes(search.toLowerCase()) ||
            tel.includes(search.toLowerCase())
          );
        })
      );
    } else {
      setFilteredRequest(request);
      setFilteredVolunteers(volunteers);
    }
  };

  const handleClickAcceptOrReject = (id, reject) => {
    acceptSubscriptionWS({ id, reject })
      .then((res) => {
        gestioneSnackbar(true, res.message, "success");
        refreshContent();
      })
      .catch((err) => gestioneSnackbar(true, err.message, "error"));
  };

  return (
    <>
      <HeaderBar
        title={t("list_volunteers.title")}
        back={true}
        path={"/dashboard/" + id_association}
      />
      <div className="list-volunteer-container container-responsive">
        <SearchInput
          search={search}
          setSearch={setSearch}
          searchFunction={searchFunction}
        />
        <CustomTabs
          tabs={[
            {
              text: t("list_volunteers.accepted"),
              onClick: () => setAccepted(true),
              isSelected: accepted,
            },
            {
              text: t("list_volunteers.waiting"),
              onClick: () => setAccepted(false),
              isSelected: !accepted,
            },
          ]}
        />
        <div>
          <Row sm={1} md={1} lg={2} xl={2} className="g-2">
            {accepted
              ? !isEmpty(filteredVolunteers)
                ? filteredVolunteers.map((item, index) => {
                    return (
                      <Col
                        sm={12}
                        md={12}
                        lg={6}
                        xl={6}
                        key={index}
                        className="d-flex justify-content-center"
                      >
                        <VolunteerDetails
                          id={item.id}
                          image={item.image ?? "/no_img.png"}
                          name={item.name + " " + item.surname}
                          phoneNumber={item.tel}
                          email={item.email}
                          role={`${
                            item.admin
                              ? t("list_volunteers.administrator")
                              : item.member
                              ? t("list_volunteers.member")
                              : t("list_volunteers.volunteer")
                          }${
                            item.admin && item.member
                              ? ` & ${t("list_volunteers.member")}`
                              : ""
                          }`}
                          listSettingsVoice={[
                            /*Permessi da admin */
                            {
                              name: item.admin
                                ? t(
                                    "list_volunteers.option.remove_admin_permission"
                                  )
                                : t("list_volunteers.option.make_admin"),
                              icon: (
                                <AdminPanelSettingsIcon
                                  style={{
                                    color: "red",
                                    width: " 20px",
                                    height: "20px",
                                  }}
                                />
                              ),
                              callback: () => {
                                changePermissionAdminWS({
                                  id_user_association: item.id,
                                  id_association: id_association,
                                  admin: !item.admin,
                                })
                                  .then((res) => {
                                    gestioneSnackbar(
                                      true,
                                      res.message,
                                      "success"
                                    );
                                    refreshContent();
                                  })
                                  .catch((err) =>
                                    gestioneSnackbar(true, err.message, "error")
                                  );
                              },
                              color: "red",
                              customDialog: true,
                              titleModal: t(
                                "list_volunteers.change_admin_permission_modal.title"
                              ),
                              descriptionModal: t(
                                "list_volunteers.change_admin_permission_modal.body"
                              ),
                            },
                            /*Permessi membro*/
                            {
                              name: item.member
                                ? t(
                                    "list_volunteers.option.remove_member_permission"
                                  )
                                : t("list_volunteers.option.make_member"),
                              icon: (
                                <HandshakeIcon
                                  style={{
                                    color: "red",
                                    width: " 20px",
                                    height: "20px",
                                  }}
                                />
                              ),
                              callback: () => {
                                changePermissionMemberWS({
                                  id_user_association: item.id,
                                  id_association: id_association,
                                  member: !item.member,
                                })
                                  .then((res) => {
                                    gestioneSnackbar(
                                      true,
                                      res.message,
                                      "success"
                                    );
                                    refreshContent();
                                  })
                                  .catch((err) =>
                                    gestioneSnackbar(true, err.message, "error")
                                  );
                              },
                              color: "red",
                              customDialog: true,
                              titleModal: t(
                                "list_volunteers.change_member_permission_modal.title"
                              ),
                              descriptionModal: t(
                                "list_volunteers.change_member_permission_modal.body"
                              ),
                            },
                            /*Rimozione volontario */
                            {
                              name: t(
                                "list_volunteers.option.remove_volunteer"
                              ),
                              icon: (
                                <DeleteForeverIcon
                                  style={{
                                    color: "red",
                                    width: " 20px",
                                    height: "20px",
                                  }}
                                />
                              ),
                              callback: () => {
                                removeVolunteerWS({
                                  id_user_association: item.id,
                                  id_association: id_association,
                                })
                                  .then((res) => {
                                    gestioneSnackbar(
                                      true,
                                      res.message,
                                      "success"
                                    );
                                    refreshContent();
                                  })
                                  .catch((err) =>
                                    gestioneSnackbar(true, err.message, "error")
                                  );
                              },
                              color: "red",
                              customDialog: true,
                              titleModal: t(
                                "list_volunteers.remove_volunteer_modal.title"
                              ),
                              descriptionModal: t(
                                "list_volunteers.remove_volunteer_modal.body"
                              ),
                            },
                          ]}
                        />
                      </Col>
                    );
                  })
                : null
              : !isEmpty(filteredRequest)
              ? filteredRequest.map((item, index) => (
                  <Col
                    sm={12}
                    md={12}
                    lg={6}
                    xl={6}
                    key={index}
                    className="d-flex justify-content-center"
                  >
                    <VolunteerInfoBox
                      id={item.id}
                      image={item.image ?? "/no_img.png"}
                      name={item.name + " " + item.surname}
                      phone={item.tel}
                      email={item.email}
                      request={true}
                      admin={item.admin}
                      idAssociation={id_association}
                      rejectCallback={() =>
                        handleClickAcceptOrReject(item.id, true)
                      }
                      acceptCallback={() =>
                        handleClickAcceptOrReject(item.id, false)
                      }
                    />
                  </Col>
                ))
              : null}
          </Row>
        </div>
        <VoidSpace />
      </div>
    </>
  );
};

export default ListVolunteer;
